<template>
  <div class="careers-page">
    <!-- 页面标题 -->
    <section class="page-banner page-banner-careers">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>人才招聘</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>人才招聘</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 招聘内容 -->
    <section class="careers-tabs-section">
      <div class="container">
        <div class="careers-layout">
          <!-- 左侧分类导航 -->
          <aside class="careers-sidebar-left">
            <div class="careers-nav-widget">
              <h4>职位分类</h4>
              <nav class="careers-nav">
                <a 
                  href="javascript:;" 
                  class="nav-item" 
                  v-for="(menu, index) in menuList" 
                  :key="menu.id" 
                  :class="{ active: activeTab === menu.id || (index === 0 && !activeTab) }" 
                  @click="switchTab(menu)"
                >
                  <i :class="getTabIcon(menu.name)"></i>
                  <span>{{ menu.name }}</span>
                </a>
              </nav>
            </div>
          </aside>

          <!-- 右侧职位列表 -->
          <div class="careers-main">
            <div class="tab-content active">
              <div class="jobs-simple-list">
                <!-- 循环渲染招聘列表 -->
                <div class="job-simple-item" v-for="item in recruitmentList" :key="item.recruitmentId">
                  <div class="job-info">
                    <h4><router-link :title="item.title" :to="'/careers/detail/' + item.recruitmentId + '?contenttpl=' + (activeContenttpl || '-1')" target="_blank">{{ item.title }}</router-link></h4>
                  </div>
                  <div class="job-action">
                    <span class="deadline">{{ item.publishTime }}</span>
                  </div>
                </div>
              </div>

               <!-- 暂无数据 -->
              <div v-if="recruitmentList.length === 0 && !loading" class="empty-state">
                <el-empty description="暂无招聘信息"></el-empty>
              </div>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper" v-if="total > 0">
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getSubMenuList, getBannerList, getRecruitmentSolrList } from '@/api/menu'

export default {
  name: 'Careers',
  data() {
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      activeTab: null,
      activeContenttpl: '',  // 当前选中菜单的 contenttpl，对应 job_category
      menuList: [],
      pcode: this.$route.query.id,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      recruitmentList: [],
      loading: false
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.pcode = newId
          this.fetchSubMenus()
        }
      },
      immediate: false
    }
  },
  created() {
    this.fetchBanner("rczp");
    this.fetchSubMenus()
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  methods: {
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    getTabIcon(name) {
      if (!name) return 'el-icon-folder';
      if (name.includes('全部')) return 'el-icon-folder';
      if (name.includes('社会')) return 'el-icon-suitcase';
      if (name.includes('校园') || name.includes('校招')) return 'el-icon-reading';
      if (name.includes('实习')) return 'el-icon-user';
      return 'el-icon-folder';
    },
    async fetchSubMenus() {
      try {
        const res = await getSubMenuList(this.pcode)
        if (res.code === 0) {
          this.menuList = res.rows || []
          if (this.menuList.length > 0 && !this.activeTab) {
            this.activeTab = this.menuList[0].id
            this.activeContenttpl = this.menuList[0].contenttpl || ''
            this.fetchRecruitmentList()
          }
        }
      } catch (error) {
        console.error('获取人才招聘二级菜单失败', error)
      }
    },
    switchTab(menu) {
      this.activeTab = menu.id
      this.activeContenttpl = menu.contenttpl || ''
      this.currentPage = 1
      this.fetchRecruitmentList()
    },
    async fetchRecruitmentList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        // contenttpl 对应 job_category，为空则查全部
        if (this.activeContenttpl) {
          params.jobCategory = this.activeContenttpl
        }
        const res = await getRecruitmentSolrList(params)
        if (res.code === 0 || res.code === 200) {
          this.recruitmentList = res.rows || []
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('获取招聘列表失败', error)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(val) {
      this.currentPage = val
      this.fetchRecruitmentList()
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-blue: #1a3a5c;
$hover-blue: #1e6fa2;
$accent-red: #c0392b;
$light-bg: #ffffff;
$border: #e8edf3;
$text-main: #333;
$text-secondary: #666;
$text-light: #999;

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ---- Banner ---- */
.page-banner-careers {
  background: url('@/assets/imgs/logo.png') no-repeat center center;
  background-size: cover;
  background-color: #2b579a; /* 人才蓝主题色 */
  color: #fff;
  padding: 60px 0;
  position: relative;

  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    position: relative;
    z-index: 2;
  }
  
  h1 { font-size: 2.2rem; font-weight: 600; margin: 0 0 15px 0; letter-spacing: 2px; }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator { color: rgba(255, 255, 255, 0.8) !important; }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner { color: #fff !important; }
}

/* ---- 招聘内容区域 ---- */
.careers-tabs-section {
  padding: 50px 0;
  background: $light-bg;
}

/* ---- 左侧边栏：分类导航 ---- */
.careers-sidebar-left {
  width: 250px;
  flex-shrink: 0;
}

.careers-nav-widget {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);

  h4 {
    margin: 0 0 20px 0;
    font-size: 1.15rem;
    color: $text-main;
    padding-bottom: 15px;
    border-bottom: 1px dashed $border;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 40px;
      height: 2px;
      background: $primary-blue;
    }
  }
}

.careers-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    color: $text-secondary;
    text-decoration: none;
    border-radius: 6px;
    transition: all 0.3s;
    font-size: 1rem;

    i {
      font-size: 1.2rem;
      transition: transform 0.3s;
    }

    &:hover {
      background: rgba($primary-blue, 0.05);
      color: $primary-blue;
      i { transform: scale(1.1); }
    }

    &.active {
      background: $primary-blue;
      color: #fff;
      font-weight: 500;
      box-shadow: 0 4px 10px rgba($primary-blue, 0.2);
    }
  }
}

.careers-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.careers-main {
  flex: 1;
  min-width: 0;
}

/* ---- 职位列表 ---- */
.jobs-simple-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.job-simple-item {
  background: #fff;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;
  border-bottom: 1px solid $border;

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 8px 8px;
  }

  &:only-child {
    border-radius: 8px;
  }

  &:hover {
    background: rgba($primary-blue, 0.02);
    
    .job-info h4 a { color: $primary-blue; }
  }

  .job-info {
    flex: 1;

    h4 {
      margin: 0;
      font-size: 1rem;
      font-weight: 400;
      a { color: $text-main; text-decoration: none; transition: color 0.2s; }
    }
  }

  .job-action {
    margin-left: 20px;
    flex-shrink: 0;

    .deadline {
      color: $text-light;
      font-size: 0.9rem;
    }
  }
}

.empty-state {
  background: #fff;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.pagination-wrapper {
  margin-top: 30px;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
::v-deep {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1e3a5f !important;
  }
}
.tab-content {
  min-height: 450px;
}
/* ================== 响应式适配 ================== */

/* Pad / Small Desktop */
@media (max-width: 992px) {
  .careers-layout {
    flex-direction: column;
  }
  
  .careers-sidebar-left {
    width: 100%;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .page-banner-careers {
    padding: 30px 0;
    h1 { font-size: 1.6rem; }
  }

  .job-simple-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 20px;
    gap: 8px;

    .job-action {
      margin-left: 0;
    }
  }
}
</style>
